<template>
    <div>
        <v-app-bar
            app
            :color="$vuetify.theme.themes.light.primary"
            flat
            :dark="$vuetify.breakpoint.smAndDown"
        >
            <v-app-bar-nav-icon
                v-if="$vuetify.breakpoint.smAndDown"
                @click.stop="drawer = !drawer"
            />
            <v-toolbar-title v-if="$vuetify.breakpoint.smAndDown">
                {{ title }}
            </v-toolbar-title>
            <v-img
                v-if="$vuetify.breakpoint.mdAndUp"
                alt="Aktion Zukunft Logo"
                class="shrink mx-2"
                contain
                src="@/assets/az-logo.png"
                transition="scale-transition"
                max-width="80"
                max-height="80"
                @click="$router.push('/')"
            />
            
            <div
                v-if="!$vuetify.breakpoint.smAndDown"
                class="d-flex justify-end toolbar_menu"
            >
                <!--
                <v-text-field
                    solo
                    dense
                    hide-details
                    class="search-field mr-4"
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Suche"
                />
                <v-divider
                    vertical
                    class="mx-4"
                />
                -->
                <template v-for="(item, index) in menuItems">
                    <template v-if="item.type === 'multi' && item.style !== 'alert' && !item.hidden">
                        <template v-for="(subItem, subIndex) in item.items">
                            <v-btn
                                v-if="subItem.type === 'icon-button-external'"
                                :key="index + '' + subIndex"
                                icon
                                rounded
                                height="36px"
                                width="36px"
                                color="white"
                                class="ml-4"
                                target="_blank"
                                :href="subItem.url"
                            >
                                <v-icon>
                                    {{ subItem.icon }}
                                </v-icon>
                            </v-btn>
                        </template>
                    </template>
                    <template v-else-if="item.style !== 'alert' && !item.hidden">
                        <v-btn
                            v-if="item.type === 'icon-button'"
                            :key="index"
                            icon
                            rounded
                            height="36px"
                            width="36px"
                            color="white"
                            class="ml-4"
                            @click="$router.push(item.route)"
                        >
                            <v-icon>
                                {{ item.icon }}
                            </v-icon>
                        </v-btn>
                        <v-btn
                            v-if="item.type === 'icon-button-external'"
                            :key="index"
                            icon
                            rounded
                            height="36px"
                            width="36px"
                            color="white"
                            class="ml-4"
                            target="_blank"
                            :href="item.route"
                        >
                            <v-icon>
                                {{ item.icon }}
                            </v-icon>
                        </v-btn>
                        <v-btn
                            v-else
                            :key="index"
                            color="white"
                            class="ml-4"
                            :text="item.type === 'text-button'"
                            @click="$router.push(item.route)"
                        >
                            {{ item.title }}
                        </v-btn>
                    </template>
                </template>
            </div>
        </v-app-bar>
        <!-- Mobile Navigation Drawer -->
        <v-navigation-drawer
            v-if="$vuetify.breakpoint.smAndDown"
            v-model="drawer"
            temporary
            app
        >
            <v-container class="d-flex p-5 justify-center align-center">
                <v-img
                    src="@/assets/az-logo.webp"
                    max-width="80%"
                />
            </v-container>
            <v-divider />
            <v-list
                nav
                dense
            >
                <template v-for="(item, i) in menuItems">
                    <template v-if="item.type === 'multi' && !item.hidden">
                        <v-divider
                            v-if="item.style === 'socials'"
                            :key="i"
                        />
                        <template v-for="(subItem, subindex) in item.items">
                            <v-list-item
                                v-if="!item.hidden"
                                :key="subindex"
                                :href="(subItem.type === 'icon-button-external' ? subItem.url : '')"
                                target="_blank"
                                :style="{backgroundColor: (item.style === 'alert' ? subItem.color + ' !important' : '')}"
                                :dark="item.style === 'alert'"
                                @click="(subItem.type !== 'icon-button-external' ? $router.push(subItem.route) : '')"
                            >
                                <v-list-item-icon>
                                    <v-icon>{{ subItem.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title style="font-size: 1.125rem; line-height: 1.25rem;">
                                        {{
                                            subItem.title
                                        }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </template>
                    <v-list-item
                        v-else-if="!item.hidden"
                        :key="i"
                        @click="$router.push(item.route)"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title style="font-size: 1.125rem; line-height: 1.25rem;">
                                {{
                                    item.title
                                }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import colors from "@/assets/styles/_colors.scss";

export default {
    props: {
        menuItems: Array,
        hideAppLogo: Boolean,
        title: String
    },
    data: () => ({
        drawer: false,
        colors
    })
}
</script>

<style lang="scss" scoped>
.search-field {
  margin-right: 16px;
  max-width: 450px;
}

.toolbar_menu {
  width: 100%;
}
</style>